/* eslint-disable */
import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl } from "../../Helpers/Config";
import {
  showLoader,
  hideLoader,
  showAlert,
  isEmpty,
  isSingleSelect,
  uploadFile,
  removeFile,
} from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Editor from "../../Clientpanel/Layout/Editor";
var module = "clientpanel/staticblocks/";
var moduleName = "Static Block";
var modulePath = "/masterpanel/staticblock";
class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editID: this.props.params?.EditID || "",
      pageloading: false,
      postdata: {
        title: "",
        description: "",
        status: "",
        images: [],
        action: "add",
      },
      btndisabled: false,
      loading: true,
      formpost: [],
      companyDetail: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    if (this.state.editID !== "") {
      var params = {
        url: `${apiUrl}staticblock/detail/${this.state.editID}`,
        type: "master",
      };
      /* var params = {
        params: "detail_id=" + this.state.editID,
        url: apiUrl + module + "details",
        type: "",
      }; */
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost != nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          setTimeout(() => {
            this.props.navigate(modulePath);
          }, 1000);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (
      this.state.companyDetail !== nextProps.detaildata &&
      this.state.editID !== ""
    ) {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;

          var statuss =
            result.status == "A" ? "Active" : "Inactive";
          var status =
            result.status !== "" &&
            result.status !== null
              ? {
                  label: statuss,
                  value: result.status,
                }
              : "";
          var clientupdatedata = {
            title: result.title,
            description: result.description,
            images:
              result.images !== "" &&
              result.images !== null
                ? result.images.split(",")
                : [],
            status: status,
            action: "edit",
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.navigate(modulePath);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }

  sateValChange = (field, value) => {
    this.setState({ btndisabled: value });
  };

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(
      update(this.state, { postdata: { [field]: { $set: value } } })
    );
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;
    const editorContent = $('#editorContent').val();
    var postObject = {
      title: postData.title,
      description: editorContent,
      images:
        postData.images.length > 0
          ? postData.images.join(",")
          : "",
      status:
        Object.keys(postData.status).length > 0 ? postData.status.value : "A",
    };

    var post_url = "staticblock";
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `staticblock/${this.state.editID}`;
      method = 'update';
    }
    this.props.getFormPost(postObject, post_url, "master", method);

  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"staticblock"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "Update" : "Add New"}{" "}
                      {moduleName}
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={modulePath}>
                      <button
                        type="button"
                        className="btn btn-outline-primary waves-effect"
                      >
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                <PostForm
                  {...this.props}
                  fields={this.state.postdata}
                  btndisabled={this.state.btndisabled}
                  onChange={this.fieldChange}
                  sateValChange={this.sateValChange}
                  onValid={this.handleSubmit}
                  error_msg={this.state.error_msg}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop:
                              $(document)
                                .find("#modulefrm .is-invalid:first")
                                .offset().top - 100,
                          },
                          100
                        );
                      }
                    }, 500);
                  }}
                />
              </div>
              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(Form));

function validationConfig(props) {
  const { title, status } = props.fields;

  return {
    fields: ["title", "status"],
    validations: {
      title: [[isEmpty, title]],
      status: [[isSingleSelect, status]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.setContent = this.setContent.bind(this);
  }

  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  setContent(value) {
    this.props.onChange("description", value);
  }

  async uplaodFiles() {
    this.props.sateValChange("btndisabled", true);
    showLoader("ImageDetails");
    showLoader("ImageContainer");
    var imagefile = document.querySelector("#images");
    const file = imagefile.files[0];
    var fileDetail = await uploadFile(file, "staticblock", "master", 'epcipay');
    if (fileDetail.status === "ok") {
      var images = this.props.fields.images;
      images.push(fileDetail.url);
      this.props.onChange("images", images);
    }
    hideLoader("ImageContainer");
    hideLoader("ImageDetails");
    $("#images").val("");
    this.props.sateValChange("btndisabled", false);
  }
  async removeImage(fileNamme, removeIndex) {
    showLoader("ImageDetails", "class");
    var fileDetail = await removeFile(fileNamme, "client", 'epcipay');
    if (fileDetail.status === "ok") {
      hideLoader("ImageDetails", "class");
      var images = this.props.fields.images;
      images.splice(removeIndex, 1);
      this.props.onChange("images", images);
    }
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgTitle,
      errMsgStatus = "";
    if ($validation.title.error.reason !== undefined) {
      errMsgTitle = $validation.title.show && (
        <span className="error">
          {$validation.title.error.reason}
        </span>
      );
    }
    if ($validation.status.error.reason !== undefined) {
      errMsgStatus = $validation.status.show && (
        <span className="error">{$validation.status.error.reason}</span>
      );
    }

    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="card-body row g-3 mt-3">
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMsgTitle !== "" &&
                  errMsgTitle !== false &&
                  errMsgTitle !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="title"
                value={fields.title}
                {...$field("title", (e) =>
                  onChange("title", e.target.value)
                )}
              />
              <label htmlFor="title">
                Title <span className="error">*</span>
              </label>
              {errMsgTitle}
            </div>
          </div>
          <div
            className={
              errMsgStatus !== "" &&
              errMsgStatus !== false &&
              errMsgStatus !== undefined
                ? "col-md-6 error-select error"
                : "col-md-6"
            }
          >
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.status}
                onChange={this.handleSelectChange.bind(this, "status")}
                placeholder="Select Status"
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "Inactive" },
                ]}
                isClearable={true}
              />
              <label className="select-box-label">
                Status<span className="error">*</span>
              </label>
              {errMsgStatus}
            </div>
          </div>
          <div className="col-md-12">
            <label>Description</label>
            <Editor
              IDName={"editorContent"}
              data={fields.description}
            />
          </div>
          <div className="col-md-12">
            <div className="card mb-4">
              <h5 className="card-header">Gallery Images</h5>
              <div className="card-body">
                <div className="dz-message needsclick">
                  Drop files here or click to upload
                  <span className="note needsclick">
                    (This is just a demo dropzone. Selected files are{" "}
                    <strong>not</strong> actually uploaded.)
                  </span>
                </div>
                <div className="fallback" id="ImageContainer">
                  <input
                    name="file"
                    type="file"
                    id="images"
                    onChange={(event) => {
                      this.uplaodFiles(event);
                      return false;
                    }}
                  />
                </div>
                {fields.images.length > 0 &&
                  fields.images.map((item, index) => {
                    return (
                      <div
                        className="dz-preview dz-processing dz-image-preview dz-success dz-complete"
                        key={index}
                      >
                        <div className="dz-details">
                          <div className="dz-thumbnail">
                            <img alt="" src={item} />
                          </div>
                        </div>
                        <a
                          className="dz-remove"
                          href={void 0}
                          onClick={this.removeImage.bind(this, item, index)}
                        >
                          Remove file
                        </a>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>

          <div className="pt-1 pb-4 pt-1 text-end">
            <button
              type="button"
              disabled={this.props.btndisabled}
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                if (!this.props.btndisabled) {
                  this.props.$submit(onValid, onInvalid);
                }
              }}
            >
              Submit
            </button>
            <Link to={modulePath}>
              <button
                type="reset"
                className="btn btn-label-secondary waves-effect"
              >
                Cancel
              </button>
            </Link>
          </div>
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
